export const MONTH_ENUM_MAP = {
  JAN: 'January',
  FEB: 'February',
  MAR: 'March',
  APR: 'April',
  MAY: 'May',
  JUN: 'June',
  JUL: 'July',
  AUG: 'August',
  SEP: 'September',
  OCT: 'October',
  NOV: 'November',
  DEC: 'December',
}

export type Month = keyof typeof MONTH_ENUM_MAP;
export default MONTH_ENUM_MAP
